import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { PurchHeadGet, PurchHeadService } from '@app/services/purch-head.service';
import { Subject, takeUntil } from 'rxjs';
import { PurchLineItem } from './purch-head-purch-lines/purch-head-purch-lines.component';

@Component({
    selector: 'tt-purch-head',
    templateUrl: './purch-head.component.html',
    styleUrls: ['./purch-head.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchHeadComponent implements OnInit, OnDestroy {
    public get?: PurchHeadGet;

    public gridPurchLines?: GridOptions<PurchLineItem>;

    public purchLinesGridReady = false;
    public documentsGridReady = false;
    public emailGridReady = false;

    @Output()
    public submit = new EventEmitter<'delete' | 'save'>();

    private destroy$ = new Subject<void>();

    constructor(
        private purchheadservice: PurchHeadService,
        public cdr: ChangeDetectorRef,
    ) {}

    public onTabChanged() {
        if (!this.get) return;

        if (this.get.gb_main === 'PURCHLINES') {
            this.purchLinesGridReady = true;
        } else if (this.get.gb_main === 'DOCUMENTS') {
            this.documentsGridReady = true;
        } else if (this.get.gb_main === 'MAILS') {
            this.emailGridReady = true;
        }

        this.cdr.markForCheck();
    }

    ngOnInit(): void {
        this.purchheadservice.currentPurchHead$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (value) => {
                if (!!value) {
                    this.get = value;

                    this.onTabChanged();
                } else {
                    delete this.get;
                }

                this.cdr.markForCheck();
            },
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
